import React from 'react';
import {
  Switch,
  Route,
  Link as RouteLink,
  useRouteMatch,
} from 'react-router-dom';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardLayout from '../_components/DashboardLayout';

import EventIcon from '@material-ui/icons/Event';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import CameraIcon from '@material-ui/icons/Camera';
import GroupIcon from '@material-ui/icons/Group';

import RecRegistryAccounts from './RecRegistryAccounts';
import RecRegistryDays from './RecRegistryDays';
import CertificateGenerations from './CertificateGenerations';
import CertificateBundleSnapshots from './CertificateBundleSnapshots';

import { useAuthStore } from '../AuthStore';

export const RecRegistry: React.FC = () => {
  const match = useRouteMatch();

  return (
    <DashboardLayout sidebar={<SideBar />}>
      <Switch>
        <Route path={`${match.path}/accounts`}>
          <RecRegistryAccounts />
        </Route>
        <Route path={`${match.path}/days`}>
          <RecRegistryDays />
        </Route>
        <Route path={`${match.path}/certificate-generations`}>
          <CertificateGenerations />
        </Route>
        <Route path={`${match.path}/certificate-bundle-snapshots`}>
          <CertificateBundleSnapshots />
        </Route>
        <Route path={match.path}>
          <h1>Rec Registry</h1>
          <p>Select an option from the sidebar.</p>
          <p>Generations show the underlying certificate data for each grouping of Registered Person Number, Accreditation Code and Generation Year. You can view the contents of each generation as either the certificate bundles or the REC Registry actions used to create them from the public Rec Registry API.</p>
          <p>Snapshots can be downloaded from the Snapshots area. The date of the snapshot is inclusive of all data from that day. By default, snapshots are generated at 1:30am on the day after the date of the snapshot.</p>
        </Route>
      </Switch>
    </DashboardLayout>
  )
};

const SideBar: React.FC = () => {
  const store = useAuthStore();

  return (
    <List>
      {store.isAdmin &&
        <ListItem button component={RouteLink} to="/rec-registry/accounts">
          <ListItemIcon><GroupIcon /></ListItemIcon>
          <ListItemText primary="Account Groups" />
        </ListItem>
      }

      <ListItem button component={RouteLink} to="/rec-registry/accounts">
        <ListItemIcon><AccountBoxIcon /></ListItemIcon>
        <ListItemText primary="Accounts" />
      </ListItem>

      {store.isAdmin &&
        <ListItem button component={RouteLink} to="/rec-registry/days">
          <ListItemIcon><EventIcon /></ListItemIcon>
          <ListItemText primary="Days" />
        </ListItem>
      }

      <ListItem button component={RouteLink} to="/rec-registry/certificate-generations">
        <ListItemIcon><CheckCircleOutlineIcon /></ListItemIcon>
        <ListItemText primary="Generations" />
      </ListItem>

      <ListItem button component={RouteLink} to="/rec-registry/certificate-bundle-snapshots">
        <ListItemIcon><CameraIcon /></ListItemIcon>
        <ListItemText primary="Snapshots" />
      </ListItem>
    </List>
  )
};

export default RecRegistry;
